import PDFDocument from 'pdfkit/js/pdfkit.standalone.js';
import { FONT, FONT_SIZE_NORMAL, SPACE, SPACE2 } from '../variables';
import { cmToPoint } from './units';

export function renderAddress(pdf: PDFDocument, body: any) {
	const resetX = pdf.x;

	pdf.fontSize(FONT_SIZE_NORMAL).font(FONT);

	const rightAligned = body.layout?.address?.alignment?.toUpperCase() === 'RIGHT';

	pdf.x += rightAligned ? cmToPoint(10) : cmToPoint(SPACE);
	pdf.y += cmToPoint(0.8);

	render(pdf, body.address, SPACE2);

	pdf.x = resetX;
	pdf.y = 244.45063984; // always same height doesn't matter if e.g. address2 or department is missing
}

function build(address: any) {
	let items: string[] = [];

	if (address.company) {
		items.push(address.company);
	}

	if (address.name) {
		items.push(address.name);
	}

	if (address.address1) {
		items.push(address.address1);
	}

	if (address.address2) {
		items.push(address.address2);
	}

	if (address.zipCode || address.city) {
		items.push(`${address.zipCode} ${address.city}`.trim());
	}

	if (address.country) {
		items.push(address.country);
	}

	items = items.filter(i => i && i.trim() !== '');

	return items;
}

function render(pdf: PDFDocument, address: any, space: number) {
	const formatted = build(address);

	for (let i = 0; i < formatted.length; i++) {
		if (i > 0 && i < formatted.length) {
			pdf.y += space;
		}

		pdf.text(formatted[i]);
	}
}
